import { createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import persistMigration from '../store/state/localFlags/persistMigration';

export default {
  key: 'x-portal',
  storage,
  whitelist: ['localFlags'],
  throttle: 100, // TODO: check if we need this
  debug: true, // TODO: make it false
  serialize: true, // TODO: check if it is default
  version: 1,
  migrate: createMigrate(
    {
      '1': persistMigration,
    },
    { debug: true },
  ),
};
